// Dependencies
import Slider from 'modules/slider';


class NewsSlider extends Slider {
  /**
   * Constructor: News Slider Constructor.
   */
  constructor(options = {}) {
    // Inherit constructor.
    super(options);

    if (!this._root || this._nodes.length === 0) {
      return;
    }
    
    // Init
    this.change(this._index, false);
  }


  /**
   * Change: Deactivate current node and activate selected one.
   *
   * @param {Int} index - Selected index.
   */
  change(index, running = true) {
    // Inherit `change` method.
    super.change(index, running);

    // Transitions
    if (running) {
      this.tOut();
      this.tIn();
    }
  }


  /**
   * TOut: Transition `Out` of the previous node.
   * 
   * @param {Function} callback - Callback method.
   */
  tOut(callback = null) {
    if (!this._prev) {
      return;
    }

    // Elements
    const mask    = this._prev.querySelector('.card__picture-mask');
    const content = this._prev.querySelector('.card__content');

    // Classnames
    this._prev.classList.remove('is-active');
    this._prev.classList.add('is-inactive');

    // Complete Method
    const complete = () => {
      // Reset Classnames
      this._prev.classList.remove('is-inactive');

      // Clean Elements
      TweenMax.set(mask, { clearProps: 'all' });
      TweenMax.set(content, { clearProps: 'all' });

      // Callback
      if (callback) {
        callback();
      }
    };

    // Transition Mask
    TweenMax.fromTo(mask, 0.6, {
      scaleX: 0,
      scaleY: 1,
    }, {
      scaleX: 1,
      scaleY: 1,
      ease: Quart.easeOut,
      onComplete: complete,
    });

    // Transition Content
    TweenMax.fromTo(content, 0.3, {
      alpha: 1,
    }, {
      alpha: 0,
      ease: Quad.easeOut,
    });
  }


  /**
   * TIn: Transition `In` of the previous node.
   * 
   * @param {Function} callback - Callback method.
   */
  tIn(callback = null) {
    if (!this._current) {
      return;
    }

    // Elements
    const mask    = this._current.querySelector('.card__picture-mask');
    const content = this._current.querySelector('.card__content');

    // Classnames
    this._current.classList.remove('is-inactive');
    this._current.classList.add('is-active');

    // Complete Method
    const complete = () => {
      // Update attributes
      this._running = false;

      // Clean Elements
      TweenMax.set(mask, { clearProps: 'all' });
      TweenMax.set(content, { clearProps: 'all' });

      // Callback
      if (callback) {
        callback();
      }
    };

    // Transition Mask
    TweenMax.fromTo(mask, 0.6, {
      scaleX: 1,
      scaleY: 1,
    }, {
      scaleX: 0,
      scaleY: 1,
      delay: 0.6,
      ease: Quart.easeOut,
      onComplete: complete,
    });

    // Transition Content
    TweenMax.fromTo(content, 0.3, {
      alpha: 0,
    }, {
      alpha: 1,
      delay: 0.6,
      ease: Quad.easeOut,
    });
  }
}

export default NewsSlider;


// WEBPACK FOOTER //
// ./src/js/layouts/news/slider.js